export enum AccessoryType {
  'STD' = 'STD',
  'RFQ' = 'RFQ',
  UR = 'UR',
  DASH = '-',
  CFG = 'CFG',
}

export enum AccessoryDisplayType {
  visible = 'visible',
  hidden = 'hidden',
  reserved = 'reserved',
}
